export default __webpack_public_path__ + "static/media/back-arrow.f0edff99.svg";